// extracted by mini-css-extract-plugin
export default {"container":"PersonInfos_container__kqfox","info":"PersonInfos_info__Bb+Wx"};